import { Box, Container, Grid2, Paper, Typography } from "@mui/material";
import Stepper from "../Stepper";

type StatusProgressProps = {
  title: any;
  action?: any;
  steps: Array<{
    label: any;
    text: any;
  }>;
  currentStep: number;
};

export default function StatusProgress({
  title,
  action,
  steps,
  currentStep,
}: StatusProgressProps) {
  return (
    <Container maxWidth="md">
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          marginBottom: 4,
          marginTop: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
        }}
      >
        <Grid2
          container
          spacing={1}
          alignItems={"center"}
          justifyContent={"center"}
          flexDirection={"column"}
        >
          <Box
            display={"flex"}
            marginBottom={1}
            {...(action && { width: "100%" })}
            justifyContent={"space-between"}
          >
            <Typography fontWeight={"bold"} variant="h6">
              {title}
            </Typography>
            {action}
          </Box>

          <Typography variant="body1">{steps[currentStep].text}</Typography>
          <Stepper steps={steps} currentStep={currentStep} />
        </Grid2>
      </Paper>
    </Container>
  );
}
